import {quadInOut} from 'svelte/easing';
export const fadeFly = (node, {duration, x, y}) => {
  return {
    duration,
    css: t => {
      const eased = quadInOut(t);

      return `
      transform: translate(${1 - (x || 0) * (1 - eased)}px, ${(y || 0) * (1 - eased)}px);
      opacity: ${eased};
      `;
    }
  };
};